
import { Api } from "../axios-config";

export interface ITrainingArea {
    _id: string;
    Name: string;
    PictureId?: string;
}

export interface IListTrainingAreas {
    data: ITrainingArea[];
}

const getAllTrainingAreas = async (): Promise<IListTrainingAreas | Error> => {
    try {
        const { data } = await Api.get("/training-areas");
        const adaptedData = Array.isArray(data) ? data : [];
        return { data: adaptedData };
    } catch (error) {
        return new Error(`Erro ao listar áreas de treinamento: ${error}`);
    }
};

const getTrainingAreaById = async (id: string): Promise<ITrainingArea | Error> => {
    try {
        const response = await Api.get(`/training-areas/${id}`);
        return response.data;
    } catch (error) {
        return new Error(`Erro ao buscar área por id: ${error}`);
    }
};

const searchTrainingAreas = async (search: string): Promise<IListTrainingAreas | Error> => {
    try {
        const response = await Api.get(`/training-areas/search`, {
            params: { name: search }
        });
        const adaptedData = Array.isArray(response.data) ? response.data : [];
        return { data: adaptedData };
    } catch (error) {
        return new Error(`Erro ao buscar áreas: ${error}`);
    }
};

const createTrainingArea = async (Name: string, PictureId?: string): Promise<ITrainingArea | Error> => {
    try {
        const response = await Api.post('/training-areas', { Name, PictureId });
        return response.data;
    } catch (error) {
        return new Error(`Erro ao criar área: ${error}`);
    }
};

const updateTrainingArea = async (id: string, Name?: string, PictureId?: string): Promise<ITrainingArea | Error> => {
    try {
        const response = await Api.put(`/training-areas/${id}`, {
            Name: Name || null,
            PictureId: PictureId || null
        });
        return response.data;
    } catch (error) {
        return new Error(`Erro ao atualizar área: ${error}`);
    }
};

const deleteTrainingArea = async (id: string): Promise<ITrainingArea | Error> => {
    try {
        const response = await Api.delete(`/training-areas/${id}`);
        return response.data;
    } catch (error) {
        return new Error(`Erro ao deletar área: ${error}`);
    }
};

export const TrainingAreaServices = {
    getAllTrainingAreas,
    getTrainingAreaById,
    searchTrainingAreas,
    createTrainingArea,
    updateTrainingArea,
    deleteTrainingArea
};



